import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {AppConfig} from '../config/app-config';
import {Store} from '@ngrx/store';
import * as fromApp from '../shared/store/app.reducer';

@Injectable({
  providedIn: 'root'
})
export class LmsActivitiesProcessFlowService {
  constructor(public http: HttpClient, public store: Store<fromApp.AppState>) {}

  getLabInfo(labCapNumber): Observable<any> {
    return this.http.get(`${AppConfig.settings.apiServer.details.remoteHost}/organization/${labCapNumber}`);
  }

  getAssignedKits(labCapNumber: string, mailingCode: string): Observable<any> {
    return this.http.get(`${AppConfig.settings.apiServer.details.remoteHost}/kits/assigned?cap=${labCapNumber}&mailing=${mailingCode}`);
  }

  getKitsForLab(activityId: string, labCapNumber: string): Observable<any> {
    return this.http.get(`${AppConfig.settings.apiServer.details.remoteHost}/activity/${activityId}/kits?cap=${labCapNumber}`);
  }

  affiliateUserToLab(labCapNumber: string): Observable<any> {
    return this.http.post(`${AppConfig.settings.apiServer.details.remoteHost}/organization/${labCapNumber}/affiliate`, null);
  }

  assignKitToUser(activityId: string, labCapNumber: string) {
    return this.http.post<any>(`${AppConfig.settings.apiServer.details.remoteHost}/activity/${activityId}/cap/${labCapNumber}`, null);
  }

  getLabSelectData(activityId: string) {
    return this.http.get<any>(`${AppConfig.settings.apiServer.details.remoteHost}/activity/${activityId}`);
  }

  getLabsHavingPurchasedQmed(activityId: string, labCapNumber: string) {
    return this.http.get<any>(`${AppConfig.settings.apiServer.details.remoteHost}/activity/${activityId}/orgs?cap=${labCapNumber}`);
  }
}
